import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { I18nProvider } from './i18n';
import { Index } from './routes/Index';
import { Settings } from './routes/Settings';
import { Profile } from './routes/Profile';

// AppRoute pulls in Babylon (~5 MB uncompressed) + OpenCV later. Lazy-load it so
// desktop landing + settings/profile don't pay for it.
const AppRoute = lazy(() => import('./routes/AppRoute').then((m) => ({ default: m.AppRoute })));

function AppLoading() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '100%', color: 'var(--ink-soft)' }}>
      …
    </div>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Suspense fallback={<AppLoading />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/app" element={<AppRoute />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="*" element={<Index />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </I18nProvider>
  );
}
